<div
  class="field-wrapper filter-name tw-relative tw-w-[190px] tw-h-[26px] tw-bg-indigo-500 tw-text-white tw-flex tw-items-center tw-justify-between tw-rounded tw-border tw-border-solid tw-border-indigo-500 tw-pl-2 tw-ml-8 tw-mr-1"
  style="padding-top: 0; padding-bottom: 0;">
  <span class="tw-font-semibold tw-leading-[.9rem]">{{column.displayName}}</span>
  <button
    class="delete-icon-btn tw-relative tw-text-white hover:tw-bg-gray-300 hover:tw-text-gray-700 hover:tw-border-transparent hover:tw-font-bold tw-transition-all tw-mr-1"
    title="Delete this filter"
    (click)="onRemove()">
    <mat-icon class="delete-icon tw-absolute hover:tw-font-bold">delete_outline</mat-icon>
  </button>
</div>

<!-- operators -->
<div
  class="field-wrapper tw-relative tw-h-[34px] tw-rounded tw-bg-white tw-flex tw-items-center tw-border tw-border-solid tw-border-neutral-400 dark:tw-bg-gray-800 tw-pl-2 tw-mx-1">
  <mat-select
    [(ngModel)]="selectedOperator"
    (ngModelChange)="setFilterParams()"
    class="operator-dropdown tw-w-40 tw-mr-3"
    panelClass="filter-operator-panel">
    <mat-option *ngFor="let item of availableOperators" [value]="item">
      {{item.displayName}}
    </mat-option>
  </mat-select>
</div>

<!-- Job Role field renderer -->
<div *ngIf="isJobRoleField">
  <!-- Role value display box with pencil icon -->
  <div
    class="field-wrapper field-wrapper-last tw-relative tw-bg-white tw-rounded tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-neutral-400 dark:tw-bg-gray-800 tw-px-3 tw-ml-1 tw-min-w-[200px] tw-h-[34px]"
    style="padding-top: 0; padding-bottom: 0;">
    <!-- Selected role display or placeholder -->
    <div class="tw-flex-1 tw-min-w-0 tw-flex tw-items-center tw-h-full">
      <span
        *ngIf="selectedRoleName"
        class="tw-font-medium tw-text-gray-800 dark:tw-text-gray-200 tw-truncate tw-block tw-leading-none">
        {{ selectedRoleName }}
      </span>
      <span
        *ngIf="!selectedRoleName"
        class="tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-leading-none">
        No role selected
      </span>
    </div>

    <!-- Pencil icon button -->
    <button
      mat-icon-button
      (click)="onViewAllRoles()"
      class="tw-w-[32px] tw-h-[32px] tw-p-0 tw-flex tw-items-center tw-justify-center"
      [matTooltip]="selectedRole ? 'Change role' : 'Pick a role'"
      matTooltipPosition="above">
      <mat-icon
        class="tw-text-[20px] tw-text-primary_purple-600 hover:tw-text-primary_purple-800 dark:tw-text-accent-teal-A200 dark:hover:tw-text-accent-teal-A100"
        >edit</mat-icon
      >
    </button>
  </div>
</div>

<!-- connector -->
<div
  class="connector-and"
  [ngClass]="{'tw-bg-white dark:tw-bg-gray-700': isEvenDepth(), 'tw-bg-gray-100 dark:tw-bg-gray-800': !isEvenDepth()}">
  {{ operator }}
</div>
